import React, { useState, useEffect, useRef } from "react";
import "./moreMenu.css";

const MoreMenu = (props) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        //onload execute ....
    }, []);

    function useOnClickOutside(ref, handler) {
        useEffect(() => {
            const listener = (event) => {
                if (!ref.current || ref.current.contains(event.target)) {
                    return;
                }
                handler(event);
            };
            document.addEventListener("mousedown", listener);
            document.addEventListener("touchstart", listener);
            return () => {
                document.removeEventListener("mousedown", listener);
                document.removeEventListener("touchstart", listener);
            };
        }, [ref, handler]);
    }

    const ref = useRef();
    useOnClickOutside(ref, () => setOpen(false));

    return (
        <div className="menuWrapper">
            <div className="moreMenu" onClick={() => setOpen(!open)}>
                <span className="dots"></span>
            </div>

            <div
                ref={ref}
                className={open ? "menuList menu-open" : "menuList menu-close"}>
                {props.title?(
                    <p className="listTitle">{props.title}</p>
                ):null}    
                <ul>
                    {props.menuList.map((menu, index) => {
                        return (

                            menu.visible ? (
                                <li key={index}>
                                    <a
                                        className={menu.disabled ?'disabled':null}
                                        onClick={() => {
                                            menu.action();
                                            setOpen(false);
                                        }}>
                                        {menu.title}
                                    </a>
                                </li>
                            ) : null                           

                        );
                    })}
                </ul>
            </div>
        </div>
    );
};

export default MoreMenu;